import type {BrandKitWithAssets,Brand, BrandColor, BrandContent, BrandFont, BrandLogo} from '@Components/mystuff-brands/brand-kits.types';
import {createBrandKitWithAssetsObject, getBrandFromList} from '@Libraries/brands-library';
import {useAppSelector} from '@/hooks';
import {useBrandContentMap} from "@Hooks/brands/useBrandContentMap";
import {useBrandLogosMap} from "@Hooks/brands/useBrandLogosMap";
import {useBrandColorsMap} from "@Hooks/brands/useBrandColorsMap";
import {useBrandFontsMap} from "@Hooks/brands/useBrandFontsMap";

export const useBrandKitWithAssets = (brandKitId: string): BrandKitWithAssets | null => {
  const brandKit = useAppSelector(({brands}) => {
    return getBrandFromList(brandKitId, brands.brands) as Brand | undefined;
  });
  const brandContentMap = useBrandContentMap();
  const allBrandLogos = useBrandLogosMap();
  const allBrandColors = useBrandColorsMap();
  const allBrandFonts = useBrandFontsMap();

  if (!brandKit) {
    return null;
  }

  return createBrandKitWithAssetsObject({
    brandKit,
    brandContent: brandContentMap,
    brandLogosMap: allBrandLogos,
    brandColorsMap: allBrandColors,
    brandFontsMap: allBrandFonts,
  }) as BrandKitWithAssets;
};
